import {IConfigurationEvaluationContext} from '../../configuration-evaluation-context/configuration-evaluation-context.interface';
import {IValueEvaluator} from '../value-evaluator.interface/value-evaluator.interface';

export class ArrayEvaluator implements IValueEvaluator {
  constructor(private _itemsEvaluators: IValueEvaluator[]) {
  }

  get evaluators(): IValueEvaluator[] {
    return this._itemsEvaluators;
  }

  evaluate(context: IConfigurationEvaluationContext): any {
    return this.evaluators.map((item, index) => item.evaluate(context.createPropertyContext(index.toString())));
  }

}
